import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from '../../styles.module.scss';
import cn from 'classnames';

type Props = {
    active?: boolean;
    handleToggle?: () => void;
    className?: string;
};

export const MenuGame: React.FC<Props> = ({ active, handleToggle, className }) => (
    <div className={cn(className, styles.tooltipContent)}>
        <Link className={styles['navbar-item']} to="/server" onClick={active ? handleToggle : undefined}>
            <Trans i18nKey="menuServer" />
        </Link>
        <Link className={styles['navbar-item']} to="/broadcasts" onClick={active ? handleToggle : undefined}>
            <Trans i18nKey="menuBroadcasts" />
        </Link>
        <Link className={styles['navbar-item']} to="/games" onClick={active ? handleToggle : undefined}>
            <Trans i18nKey="menuGames" />
        </Link>
        <Link className={styles['navbar-item']} to="/demo" onClick={active ? handleToggle : undefined}>
            <Trans i18nKey="menuBoard" />
        </Link>
    </div>
);
